(function () {
  // Cart rules for bookings: put the chosen appointment into the add-to-cart request, keep each booking at
  // quantity 1, and allow only one booking per date per cart. Works with whatever form/drawer the theme uses.
  var active = null; // { handle, variants, getChoice, setStatus, root }

  function blocked(msg) {
    return Promise.resolve(new Response(JSON.stringify({ status: 422, message: msg, description: msg }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
  }
  function bookingDate(item) {
    var p = (item && item.properties) || {};
    return p._booking_start ? String(p._booking_start).slice(0, 10) : '';
  }
  function getCart(f) {
    return f('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Only touch requests that add a variant of this block's product (not quick-add buttons for other products).
  function isOurs(body) {
    if (!active.variants.length) return true;
    var id = '';
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) id = String(body.get('id') || '');
      else if (typeof body === 'string') { var j = JSON.parse(body); id = String(j.id || (j.items && j.items[0] && j.items[0].id) || ''); }
    } catch (e) {}
    return !id || active.variants.indexOf(id) !== -1;
  }

  // When the cart is changed (cart page / drawer), never let a booking line go above quantity 1.
  function clampQuantities(init, f) {
    var json;
    try { json = JSON.parse(init.body); } catch (e) { return Promise.resolve(init); }
    return getCart(f).then(function (cart) {
      var items = cart.items || [];
      var find = function (k) { return items.filter(function (i) { return String(i.key) === String(k) || String(i.id) === String(k); })[0]; };
      if (json.updates && !Array.isArray(json.updates)) {
        Object.keys(json.updates).forEach(function (k) {
          if (bookingDate(find(k)) && Number(json.updates[k]) > 1) json.updates[k] = 1;
        });
      } else if (Array.isArray(json.updates)) {
        json.updates = json.updates.map(function (q, i) { return bookingDate(items[i]) && Number(q) > 1 ? 1 : q; });
      } else if (json.quantity !== undefined) {
        var it = json.line ? items[Number(json.line) - 1] : find(json.id);
        if (bookingDate(it) && Number(json.quantity) > 1) json.quantity = 1;
      }
      return Object.assign({}, init, { body: JSON.stringify(json) });
    }).catch(function () { return init; });
  }

  if (!window.__bkFetchPatched) {
    window.__bkFetchPatched = true;
    var origFetch = window.fetch;
    var rawFetch = function () { return origFetch.apply(window, arguments); };
    window.fetch = function (input, init) {
      var self = this;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';

        if (init && typeof init.body === 'string' && /\/cart\/(change|update)(\.js)?([?#]|$)/.test(url)) {
          return clampQuantities(init, rawFetch).then(function (fixed) { return origFetch.call(self, input, fixed); });
        }

        if (active && /\/cart\/add(\.js)?([?#]|$)/.test(url) && init && init.body && isOurs(init.body)) {
          var c = active.getChoice();
          if (!c.start) {
            var msg = 'Please choose a date and time first.';
            active.setStatus(msg, true);
            try { active.root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
            return blocked(msg);
          }
          var props = { 'Appointment': c.label, '_booking_start': c.start, '_booking_product': active.handle, '_hold_id': c.hold };
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            Object.keys(props).forEach(function (k) { init.body.set('properties[' + k + ']', props[k]); });
            init.body.set('quantity', '1');
          } else if (typeof init.body === 'string') {
            try {
              var json = JSON.parse(init.body);
              (json.items || [json]).forEach(function (it) { it.properties = Object.assign({}, it.properties, props); it.quantity = 1; });
              init = Object.assign({}, init, { body: JSON.stringify(json) });
            } catch (e) {}
          }
          var date = c.start.slice(0, 10), sent = init;
          return getCart(rawFetch).then(function (cart) {
            var dup = (cart.items || []).some(function (i) { return bookingDate(i) === date; });
            if (dup) {
              var m = 'You already have a booking for that date in your cart. Choose a different date, or remove the other booking first.';
              active.setStatus(m, true);
              return blocked(m);
            }
            return origFetch.call(self, input, sent);
          }, function () { return origFetch.call(self, input, sent); });
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  function init(root) {
    if (root.dataset.bkReady) return;
    root.dataset.bkReady = '1';
    var server = (root.dataset.server || '').trim().replace(/\/$/, '');
    var handle = root.dataset.product;
    var el = function (n) { return root.querySelector('[data-bk="' + n + '"]'); };
    var grid = el('grid'), monthEl = el('month'), prev = el('prev'), next = el('next');
    var timeWrap = el('timewrap'), timeSel = el('time'), statusEl = el('status');
    var slots = {}, tz = '', viewY = 0, viewM = 0, minKey = '', maxKey = '', selectedDate = '';

    function setStatus(msg, isError) { statusEl.textContent = msg; statusEl.dataset.error = String(!!isError); }
    function pad(n) { return String(n).padStart(2, '0'); }
    function key(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
    function fmtTime(iso) { return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit', timeZone: tz }).format(new Date(iso)); }
    function fmtFull(iso) { return new Intl.DateTimeFormat(undefined, { dateStyle: 'full', timeStyle: 'short', timeZone: tz }).format(new Date(iso)); }
    var chosen = { iso: '', start: '', hold: '', label: '', mins: 20, at: 0 };
    var lastHold = '';
    var storeKey = 'bk-choice-' + handle;
    active = { handle: handle, variants: (root.dataset.variants || '').split(',').filter(Boolean), getChoice: function () { return chosen; }, setStatus: setStatus, root: root };
    function saveChoice() { try { if (chosen.hold) sessionStorage.setItem(storeKey, JSON.stringify(chosen)); else sessionStorage.removeItem(storeKey); } catch (e) {} }
    try { var saved = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); if (saved && saved.hold && Date.now() - saved.at < 19 * 60000) { chosen = saved; lastHold = saved.hold; selectedDate = saved.iso.slice(0, 10); } } catch (e) {}
    function applyChoice() { el('start').value = chosen.start; el('hold').value = chosen.hold; el('label').value = chosen.label; }
    function clearChoice() { chosen = { iso: '', start: '', hold: '', label: '', mins: 20, at: 0 }; applyChoice(); saveChoice(); }
    function reservedMsg() { return 'Reserved: ' + chosen.label + '. Add to cart and check out within ' + chosen.mins + ' minutes to keep it.'; }

    // Attach our hidden inputs to the theme's add-to-cart form and require a time before it submits.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      if (!form.id) form.id = 'bk-form-' + root.id;
      root.querySelectorAll('input').forEach(function (i) { if (!form.contains(i)) i.setAttribute('form', form.id); });
      form.addEventListener('submit', function (e) {
        if (!el('start').value) {
          e.preventDefault(); e.stopImmediatePropagation();
          setStatus('Please choose a date and time first.', true);
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    function renderMonth() {
      var first = new Date(viewY, viewM, 1);
      monthEl.textContent = first.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
      grid.innerHTML = '';
      var sunday = new Date(2024, 0, 7);
      for (var i = 0; i < 7; i++) {
        var h = document.createElement('div');
        h.className = 'bk__dow';
        h.textContent = new Date(sunday.getTime() + i * 86400000).toLocaleDateString(undefined, { weekday: 'narrow' });
        grid.appendChild(h);
      }
      for (var j = 0; j < first.getDay(); j++) { var blank = document.createElement('div'); blank.className = 'bk__blank'; grid.appendChild(blank); }
      var days = new Date(viewY, viewM + 1, 0).getDate();
      for (var d = 1; d <= days; d++) {
        (function (day) {
          var k = key(viewY, viewM, day);
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'bk__day'; b.textContent = day;
          b.disabled = !slots[k];
          b.setAttribute('aria-pressed', String(k === selectedDate));
          if (slots[k]) b.setAttribute('aria-label', new Date(viewY, viewM, day).toLocaleDateString(undefined, { dateStyle: 'full' }));
          b.onclick = function () { pickDate(k); };
          grid.appendChild(b);
        })(d);
      }
      prev.disabled = key(viewY, viewM, 1) <= minKey.slice(0, 8) + '01';
      next.disabled = key(viewY, viewM + 1, 1) > maxKey;
    }

    function pickDate(k, keep) {
      selectedDate = k; if (!keep) clearChoice();
      timeSel.innerHTML = '';
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Select a time'; timeSel.appendChild(ph);
      slots[k].forEach(function (iso) { var o = document.createElement('option'); o.value = iso; o.textContent = fmtTime(iso); timeSel.appendChild(o); });
      timeWrap.hidden = false;
      if (keep && chosen.iso) timeSel.value = chosen.iso;
      renderMonth();
      if (keep && chosen.start) { applyChoice(); setStatus(reservedMsg()); } else setStatus('Choose a time (' + tz.replace('_', ' ') + ').');
    }

    // The theme can redraw this block from server HTML (e.g. after a form change); rebuild if our calendar was wiped.
    function restore() {
      if (!Object.keys(slots).length || grid.children.length) return;
      if (selectedDate && slots[selectedDate]) pickDate(selectedDate, true); else renderMonth();
    }
    new MutationObserver(restore).observe(root, { childList: true, subtree: true });
    ['change', 'input'].forEach(function (t) { timeSel.addEventListener(t, function (e) { e.stopPropagation(); }); });

    timeSel.addEventListener('change', function () {
      clearChoice();
      var iso = timeSel.value;
      if (!iso) { setStatus('Choose a time.'); return; }
      setStatus('Reserving...');
      fetch(server + '/api/hold', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ product: handle, start: iso, replaceHold: lastHold || undefined }) })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) { setStatus(res.data.error || 'Could not reserve that time.', true); timeSel.value = ''; load(); return; }
          chosen = { iso: iso, start: res.data.start, hold: res.data.holdId, label: fmtFull(res.data.start), mins: res.data.expiresInMinutes, at: Date.now() };
          lastHold = res.data.holdId; applyChoice(); saveChoice();
          setStatus(reservedMsg());
        })
        .catch(function () { setStatus('Could not reserve that time. Please try again.', true); });
    });

    prev.onclick = function () { viewM--; if (viewM < 0) { viewM = 11; viewY--; } renderMonth(); };
    next.onclick = function () { viewM++; if (viewM > 11) { viewM = 0; viewY++; } renderMonth(); };

    function load() {
      var end = new Date(Date.now() + 61 * 86400000);
      var to = key(end.getFullYear(), end.getMonth(), end.getDate());
      fetch(server + '/api/slots?product=' + encodeURIComponent(handle) + '&to=' + to + ((chosen.hold || lastHold) ? '&hold=' + encodeURIComponent(chosen.hold || lastHold) : ''))
        .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.json(); })
        .then(function (data) {
          slots = data.slots; tz = data.timezone;
          var dates = Object.keys(slots).sort();
          if (!dates.length) { grid.innerHTML = ''; monthEl.textContent = ''; prev.disabled = next.disabled = true; setStatus('No times are available right now. Please check back soon.', true); return; }
          minKey = dates[0]; maxKey = dates[dates.length - 1];
          if (selectedDate && !slots[selectedDate]) { selectedDate = ''; clearChoice(); }
          if (!selectedDate) timeWrap.hidden = true;
          if (!selectedDate || !viewY) { var p = (selectedDate || minKey).split('-').map(Number); viewY = p[0]; viewM = p[1] - 1; }
          if (selectedDate) pickDate(selectedDate, true); else { renderMonth(); setStatus('Choose a highlighted date.'); }
        })
        .catch(function () { setStatus('Times could not be loaded. Please refresh the page.', true); });
    }
    load();
  }

  // Hide the quantity controls on booking lines in the cart page / drawer (a booking is always quantity 1).
  var QTY = 'quantity-selector-component, quantity-input, .quantity-selector';
  function topLevel(scope) {
    return Array.prototype.filter.call(scope.querySelectorAll(QTY), function (n) { return !n.parentElement || !n.parentElement.closest(QTY); });
  }
  function lockQuantities() {
    topLevel(document).forEach(function (ctl) {
      if (ctl.dataset.bkLocked) return;
      var row = ctl;
      for (var i = 0; i < 6 && row.parentElement; i++) {
        if (topLevel(row.parentElement).length > 1) break; // stop at the single cart line
        row = row.parentElement;
      }
      if (/Appointment:/.test(row.textContent)) { ctl.style.display = 'none'; ctl.dataset.bkLocked = '1'; }
    });
  }
  var lockQueued = false;
  function queueLock() { if (lockQueued) return; lockQueued = true; setTimeout(function () { lockQueued = false; lockQuantities(); }, 50); }

  function initAll() { document.querySelectorAll('.bk[data-bk-root]').forEach(init); queueLock(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  new MutationObserver(function () { if (document.querySelector('.bk[data-bk-root]:not([data-bk-ready])')) initAll(); queueLock(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
